var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M15.73 15.926v-4.92a4.4 4.4 0 0 0-.389-1.87 3.07 3.07 0 0 0-1.109-1.318q-.74-.512-1.732-.512-.993 0-1.732.512-.72.472-1.11 1.319a4.4 4.4 0 0 0-.389 1.87v4.92h6.462zm1.635-.846L19 16.733v.807H6v-.807l1.635-1.653v-4.074q0-1.928.953-3.326.973-1.436 2.705-1.87v-.57q0-.512.35-.876Q11.994 4 12.5 4t.866.364c.36.364.36.535.36.876v.57q1.713.434 2.686 1.89.953 1.396.953 3.306zM12.5 20q-.662 0-1.148-.472a1.53 1.53 0 0 1-.487-1.142h3.27q0 .67-.487 1.142A1.6 1.6 0 0 1 12.5 20"
})));
export default SvgChannelNotification;